export const urlPath = ''
export const urlHost = process.env.URL + urlPath
// export const baseApi = 'http://192.168.100.12:8000'
export const baseApi = 'https://dev.api.paninti.com/'
export const devtools = true
export const productionTip = true
// URL
export const urlUserDashboard = '/user/dashboard'
